import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'

const Block = styled.div`
  display: grid;
  grid-flow: column;
  grid-template-columns: 1fr 1fr;
  gap: ${sv.spacing.xlarge};
`

export default { Block }
